<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {

      }
    },
    mounted() {
      this.getIsSilent();
    },
    methods: {
      getIsSilent() {
        this.getAjax(this.$api.getwhiteColours, {}, function(res) {
          if (res.code == 1) {
            if (res.data.deploy == "white") {
              // 黑白
              $("html").addClass("silent-body");
            }
          }
        })
      }
    }
  }
</script>

<style>
  /* 黑白模式 */
  .silent-body {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: "gray";
  }
  #app.body-bg {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    background-attachment: fixed;
    padding-top: 220px;
  }

  #app.body-bg .web-body {
    width: 1220px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: #FFFFFF;
    overflow: hidden;
  }

  #app.body-bg .header-nav {
    background-color: #ffffff;
  }

  #app.body-bg .header-nav ul {
    background-color: #131313;
  }

  /* 背景顶部跳转链接 */
  #app.body-bg .web-header .web-ad {
    width: 1200px;
    margin-left: 10px;
    height: 220px;
    display: block;
    position: fixed;
    top: 0;
    cursor: pointer;
  }

  #app.body-bg .web-main {
    position: relative;
  }

  @media screen and (max-width: 800px) {
    #app.body-bg {
      background-size: 100%;
      padding-top: 13vw;
    }

    #app.body-bg .web-body {
      width: 100%;
    }

    #app.body-bg .web-header .web-ad {
      width: 100%;
      height: 13vw;
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue